import { CopyRightText } from "@/components/custom/CopyRightText"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { Label } from "@/components/ui/label"
import { TCSLink } from "@/components/custom/Link/TCSLink"
import { Auth } from "@/API/Auth"
import { useState } from "react"
import { AuthSchema } from "@/constants/auth/auth"
import { ResponseMessageBox } from "@/components/custom/ResponseMessageBox/ResponseMessageBox"
import { AuthMessage } from "@/constants/auth/auth"
import { ForgotPasswordForm } from "@/types/auth"
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import {
  Card,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

export const ForgotPassword = () => {
  const [formMessage, setFormMessage] = useState<string>('')
  const form = useForm<ForgotPasswordForm>({
    resolver: zodResolver(AuthSchema.forgotPassword),
    defaultValues: {
      email: "",
    },
  })

  const onSubmit = async (
    values: ForgotPasswordForm
  ) => {
    const response = await Auth.forgotPassword(values)
    if (!response.data && response.err) {
      setFormMessage(response.err)
    } else {
      setFormMessage(AuthMessage.PASSWORD_RESET_LINK_SENT)
      form.reset({ email: "" })
    }
  }

  return <div className="bg-opacity-50 h-screen py-20 flex flex-col justify-center items-center">
    <Card className="auth-card w-sm flex-column p-10">
      <CardHeader className="mb-12">
        <CardTitle>The Camp Stack</CardTitle>
      </CardHeader>

      {/* Response Message */}
      {formMessage && <ResponseMessageBox messageTitle={formMessage} />}

      <Label className="flex justify-start font-semibold text-primary text-xl mb-1">
        Forgot Password
      </Label>
      <p className="text-left text-secondary mb-6 leading-5">
        Enter your email for us to send a secure link to reset your password.
      </p>

      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="space-y-8"
        >
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel
                  className="flex justify-start mb-2 font-semibold text-primary"
                  isRequired
                >
                  Email Address
                </FormLabel>
                <FormControl>
                  <Input
                    hasError={!!form.formState.errors.email}
                    type="email"
                    placeholder="john@example.com"
                    {...field}
                  />
                </FormControl>
                <FormMessage
                  showIcon={true}
                  className="flex justify-start"
                />
              </FormItem>
            )}
          />
          <Button type="submit" className="w-full font-semibold">
            Send Link
          </Button>
        </form>
      </Form>

      <CardFooter className="pt-3 flex justify-center">
        <TCSLink
          linkTo='/login'
          className=" flex justify-start items-center mt-3"
          linkText="Back to Log In"
        />
      </CardFooter>
    </Card>
    <CopyRightText />
  </div>
}
